module.exports = __webpack_public_path__ + "img/sheqingMinyi.b21b93c3.png";